__turbopack_context__.v({
  "ChecklistItem": "ChecklistItem-module-scss-module__cFqicG__ChecklistItem",
  "Icon": "ChecklistItem-module-scss-module__cFqicG__Icon",
  "Title": "ChecklistItem-module-scss-module__cFqicG__Title",
});
